// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__6vYob"};